<script setup lang="ts">
import SourceButton from '~/components/ui/SourceButton.vue'

defineProps<{
  showDelete: boolean
  deleteDisabled?: boolean
  cancelDisabled?: boolean
  submitDisabled?: boolean
  submitLabel: string
  wrapActions?: boolean
}>()

const emit = defineEmits<{
  delete: []
  cancel: []
  submit: []
}>()
</script>

<template>
  <div class="footer" :class="{ 'footer--no-delete': !showDelete }">
    <SourceButton
      v-if="showDelete"
      size="small"
      icon="delete"
      text="Supprimer"
      type="deleteSecondary"
      :disabled="deleteDisabled"
      @click="emit('delete')"
    />
    <div class="footer-right" :class="{ 'footer-right--wrap': wrapActions }">
      <SourceButton
        size="small"
        text="Annuler"
        type="deleteTertiary"
        :disabled="cancelDisabled"
        @click="emit('cancel')"
      />
      <SourceButton
        size="small"
        icon="save"
        :text="submitLabel"
        type="primary"
        :disabled="submitDisabled"
        @click="emit('submit')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/components/entity-form" as *;

.footer-right :deep(.source-button) {
  min-width: 140px;
}

.footer-right--wrap {
  justify-content: center;
  flex-wrap: wrap;
  align-items: stretch;
}
</style>
